var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1360)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_1360)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.310059H20V20.3101H0V0.310059Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.310059V20.3101M17.07 3.23906L2.928 17.3811M20 10.3101H0M17.07 17.3811L2.928 3.23906M13.824 19.5491L6.171 1.07006M19.242 14.1371L0.765 6.48306M0.762 14.1371L19.239 6.48306M6.176 19.5491L13.829 1.07006",
    stroke: "#18181B",
    strokeWidth: 1.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.310059)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_1360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.310059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.9d1df79bfab8e8bafddb26277f8788d0.svg";
export { ForwardRef as ReactComponent };